import { render, staticRenderFns } from "./MailInputSection.vue?vue&type=template&id=688c6d89&scoped=true"
import script from "./MailInputSection.vue?vue&type=script&lang=ts"
export * from "./MailInputSection.vue?vue&type=script&lang=ts"
import style0 from "./MailInputSection.vue?vue&type=style&index=0&id=688c6d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c6d89",
  null
  
)

export default component.exports